import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    disabled,
    overflowEllipsisWidth
  } = _ref;
  return {
    leftIconStyle: icon => _objectSpread({}, icon.props.colorToken ? {
      colorToken: icon.props.colorToken,
      colorTokenArgs: _objectSpread({
        interactiveState: disabled ? 'disabled' : 'default'
      }, icon.props.colorTokenArgs)
    } : icon.props.color ? {
      color: icon.props.color
    } : {
      colorToken: 'colors/text/default',
      colorTokenArgs: {
        interactiveState: disabled ? 'disabled' : 'default'
      }
    }),
    titleStyle: _objectSpread(_objectSpread({
      marginBottom: 0,
      marginTop: 0,
      color: designContext.get('colors/text/default', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('text-style/text/paragraphs/body/medium').styles()), {}, {
      lineHeight: 20,
      textAlign: 'left',
      wordBreak: 'break-word'
    }, overflowEllipsisWidth && {
      maxWidth: overflowEllipsisWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    paragraphStyle: _objectSpread(_objectSpread(_objectSpread({
      marginBottom: 0,
      marginTop: 0,
      color: designContext.get('colors/text/neutral', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('text-style/text/paragraphs/body/regular').styles()), {}, {
      lineHeight: 20,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left'
    }, overflowEllipsisWidth && {
      maxWidth: overflowEllipsisWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      wordBreak: 'break-word'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map